//page表示時フェードイン
document.addEventListener("DOMContentLoaded", function () {
  document.body.style.opacity = 1;
});
document.addEventListener("DOMContentLoaded", () => {
  const fade_item = document.querySelectorAll(".js-fade");

  // 要素がビューポートに表示・非表示になった際の処理
  const options = {
    root: null, // ビューポートを基準に観測
    rootMargin: "-10% 0px", // ビューポートからの余白を設定
    threshold: 0, // イベントをトリガー
  };
  const observer = new IntersectionObserver(IntersectFunction, options);
  // 各要素を監視
  fade_item.forEach((item) => {
    observer.observe(item);
  });
  function IntersectFunction(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // ビューポートに入った場合
        entry.target.classList.add("is-show");
      } else {
        // ビューポートから外れた場合
        // entry.target.classList.remove("is-show");
      }
    });
  }
});
